<template>
    <div :class="{
        'tag-box': true,
        'tag-more': showMore,
        open: open
    }">
        <div class="tag-list">
            <a v-for="item in list" :key="item[props.value]" :class="{ active: value == item[props.value] }" v-text="item[props.label]" @click="handleClick(item[props.value])"></a>
        </div>
        <a class="tag-btn" v-if="showMore" @click="open = !open">
            <span v-text="open ? '收起&gt;' : '更多&gt;'"></span>
        </a>
    </div>
</template>

<script>
export default {
    data () {
        return {
            open: false
        }
    },
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
        showMore: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Array, Number, String]
        },
        props: {
            type: Object,
            default() {
                return {
                    label: 'label',
                    value: 'value'
                }
            }
        },
        change: {
            type: Function
        }
    },
    methods: {
        handleClick(value) {
            this.$emit('update:value', value)
            this.change(value)
        }
    }
}
</script>
